import React from 'react'

import Chart from './AreaChart.d3'
import ChartWrapper from '../ChartWrapper'

const AreaChart = ({
  data,
  yKey,
  inModal,
}) => {
  const updateProps = React.useMemo(() => ({ data, inModal }), [data, inModal])

  return (
    <ChartWrapper
      Chart={Chart}
      initProps={{ data, yKey, inModal }}
      updateProps={updateProps}
      margin={{ BOTTOM: 50, LEFT: 50, TOP: 20 }}
    />
  )
}

export default AreaChart
